import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { folderAccess } from './models/folderAccess.model';
import { system_manager, auth_server } from '../assets/conf_urls.json';
import { userAccessMapping } from './models/userAccessMapping.model';

@Injectable()
export class GlobalSharedService {
  private token = localStorage.getItem('accessToken');
  constructor(private http: HttpClient) {
  }

  getAllAccessFolders(): Observable<{ data: folderAccess[] }> {
    return this.http.post<{ data: folderAccess[] }>(
      system_manager.services,
      {
        "event": "select_folders_mapping"
      })
  }

  getUserAccessMappingFolders(userId: number): Observable<{ data: userAccessMapping[] }> {
    return this.http.post<{ data: userAccessMapping[] }>(
      system_manager.services,
      {
        "event": "getUserAccessFolders",
        "userId": userId
      })
  }



  updateAccessFolders(userId: number, foldersArr: number[]): Observable<{ data: folderAccess[] }> {
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.token, responseType: 'text' });
    return this.http.post<{ data: folderAccess[] }>(
      auth_server.updateByIdUserAccess,
      {
        "userId": userId,
        "folders": foldersArr
      }, { headers })
  }

}
